import React, { useRef } from "react";

// Css
import classes from "./PremiumImagePriceCard.module.css";

// Mui
import { Box, FormControlLabel, Radio, useRadioGroup } from "@mui/material";

// Jds
import { Text } from "@jds/core";

const PriceControlLabel = (props) => {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
        checked = radioGroup.value === props.value;
    }
    return (
        <FormControlLabel
            control={<Radio />}
            checked={checked}
            sx={{ marginRight: 0 }}
            {...props}
        />
    );
};

export default function PremiumImagePriceCard(props) {
    const { controlLabelProps, value, data, price } = props;
    const controlLabelRef = useRef(null);
    const cardClickHandler = () => {
        if (controlLabelRef.current) {
            controlLabelRef.current.click(); // This simulates the click event on the child
        }
    };
    return (
        <div
            className={`${classes["premium-price__card"]} ${controlLabelProps.value === value && classes.active
                }`}
            onClick={cardClickHandler}
        >
            <PriceControlLabel inputRef={controlLabelRef} {...controlLabelProps} />
            <div className={classes["premium-price__details"]}>
                <div className={classes["premium-price__details-header"]}>
                    <Text
                        text={data?.product?.name || "Premium Photos Plan"}
                        appearance="body-m-bold"
                    />
                    <Text text={`${price || ""}/photo`} appearance="body-l-bold" />
                </div>
                <Box>
                    <Text text={data?.billingType} />
                </Box>
            </div>
        </div>
    );
}
